import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
} from 'react';
import { ErrorResponse } from '../services/HttpResponse';
import { Nullable, Optional } from '../types/common';

export type ErrorCode = [(errorResponse: ErrorResponse) => void];
export type Error = {
  title: string;
  text: string;
  btnText: string;
};

export type ErrorState = {
  error: Error | undefined;
};

export interface ErrorContextInterface {
  state: ErrorState;
  showTitleTextError: (title: string, text: string, btnText: string) => void;
  setError: Dispatch<SetStateAction<Optional<Error>>>;
  closeError: () => void;
}
export const ErrorContext = createContext<Nullable<ErrorContextInterface>>(
  null
);

// `children` comes from Gatsby PageWrapper and is of general type object.
export interface ErrorPageProps {
  children: object;
}

export const ErrorProvider: React.FC<ErrorPageProps> = ({
  children,
}): JSX.Element => {
  const [error, setError] = React.useState<Error>();

  const showTitleTextError = (
    title: string,
    text: string,
    btnText: string
  ): void => {
    setError({
      title,
      text,
      btnText,
    });
  };
  const closeError = (): void => {
    setError(undefined);
  };
  const value = {
    state: {
      error,
    },
    setError,
    closeError,
    showTitleTextError,
  };
  return (
    <ErrorContext.Provider value={value}>{children}</ErrorContext.Provider>
  );
};

export const useError = (): ErrorContextInterface =>
  useContext(ErrorContext) as ErrorContextInterface;
